<template>

  <v-list-item-title v-if="typeof data.item === 'string'" class="service-list-select-item custom-service">
    {{data.item}}
  </v-list-item-title>

  <v-layout
    data-qa="dropdown-item"
    class="service-list-select-item"
    :class="{'selection-item': isSelectionItem, mobile: !$vuetify.breakpoint.mdAndUp}"
    align-center
    v-else>
    <v-img
       v-if="data.item && (data.item.photo_path || data.item.image_url || data.item.image_path) && isPhotoUrlValid"
       class="service-image"
       :min-height="!$vuetify.breakpoint.mdAndUp && isSelectionItem ? '48px' : '32px'"
       :min-width="!$vuetify.breakpoint.mdAndUp && isSelectionItem ? '48px' : '32px'"
       :src="photo_path || data.item.photo_path"/>
    <v-layout v-else align-center justify-center class="service-image"
    :style="{
      backgroundColor: brandColor
    }"
    >
      <v-icon>
        icon-Services
      </v-icon>
    </v-layout>
    <v-list-item-content>
      <v-list-item-title >
        <v-layout justify-space-between>
              <span data-qa="service-name"  class="service-name">
                {{data.item.name}}
              </span>
          <span class="service-price" v-if="isPaidService && parseFloat(data.item.price) > 0">
                {{data.item.price | amountWithCurrency(data.item.currency, '', 2) }}
              </span>
        </v-layout>

      </v-list-item-title>
      <v-list-item-subtitle>
        <v-layout justify-space-between>
          <span class="interaction-type" v-if="data.item.interaction_type && !(!$vuetify.breakpoint.mdAndUp && !isSelectionItem)">
            {{$t(`appointment.info.interaction_types.${data.item.interaction_type}.short_type`) }}
          </span>
          <span class="service-duration">
            {{ data.item.duration | formatDuration(translationFunc) }}
          </span>
        </v-layout>

      </v-list-item-subtitle>
    </v-list-item-content>
  </v-layout>

</template>

<script>
  import {imageService} from "@/modules/common/services"
  export default {
    props: {
      data: {
        type: Object,
        required: true,
      },
      isSelectionItem: {
        type: Boolean,
        default: false,
      }
    },
    watch: {
      data: {
        handler() {
          if (this.isSelectionItem) {
            this.setServiceImageUrl()
          }
        }
      }
    },
    data() {
      return {
        translationFunc: null,
        photo_path: '',
      }
    },
    async created() {
      this.translationFunc = this.$t.bind(this);
      this.setServiceImageUrl()
    },
    methods: {
      async setServiceImageUrl() {
        if(this.data.item && this.data.item.photo_path && !this.isPhotoUrlValid) {
          this.photo_path = await imageService.getImageUrl(this.data.item.photo_path, 'vue_wizard_iframe')
        } else if (this.data.item && (this.data.item.image_url || this.data.item.image_path) && !this.isPhotoUrlValid) {
          this.photo_path = await imageService.getImageUrl(this.data.item.image_url || this.data.item.image_path, 'vue_wizard_iframe')
        } else if (this.isPhotoUrlValid) {
          this.photo_path = this.data.item.image_url || this.data.item.image_path
        }
      }
    },
    computed: {
      isPaidService() {
        return ['paid_non_secured', 'paid_force', 'paid'].indexOf(this.data.item.charge_type) !== -1
      },
      isPhotoUrlValid() {
        let res = true;
        try {
          let path = this.photo_path || (this.data.item && (this.data.item.photo_path || this.data.item.image_url || this.data.item.image_path))
          new URL(path)
        } catch {
          res = false
        }
        return res
      },
      brandColor() {
        return this.$store && this.$store.getters && this.$store.getters['brandModule/brandColor'];
      },
    }
  }

</script>

<style lang="scss" scoped>
  @import '@/assets/scss/abstract/_i18n-mixins';
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
  .service-list-select-item {
    max-height: 100%;
    overflow: hidden;
    &.custom-service {
      color: rgba(0, 0, 0, 0.87);
      font-weight: 500;
      font-size: 15px;
      letter-spacing: -0.2px;
      line-height: 24px;
      @include md-and-up {
        font-size: 13px;
      }
    }
    .service-image {
      border-radius: 4px;
      max-width: 32px;
      min-height: 32px;
      @include i-margin-mirror(0, 12px);
      i {
        color: #ffffff;
        font-size: 20px;
      }
    }
    .service-price {
      font-size: 13px;
      font-weight: 500;
      margin: 2px 0px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.87);
    }
    .service-name {
      font-size: 15px;
      line-height: 20px;
      letter-spacing: -0.2px;
      margin: 2px 0;
      color: rgba(0, 0, 0, 0.87);
      overflow: hidden;
      text-overflow: ellipsis;
      text-transform: none;
    }
    .interaction-type {
      font-size: 12px;
      line-height: 14px;
      margin: 2px 0;
      color: rgba(0, 0, 0, 0.62);
      letter-spacing: -0.3px;
    }
    .service-duration {
      font-size: 12px;
      margin: 2px 0;
      line-height: 14px;
      letter-spacing: -0.3px;
      color: rgba(0, 0, 0, 0.62);
    }
    &.selection-item, &.placeholder-item {
      .service-name {
        font-weight: 500;
        font-size: 15px;
      }
      &.mobile {
        .service-image {
          max-width: 48px;
          min-height: 48px;
        }
        .service-name {
          font-size: 15px;
          line-height: 1.33;
        }
        .interaction-type {
          font-size: 14px;
        }
        i {
          font-size: 24px;
        }
      }
    }
    &.placeholder-item {
      .service-name {
        color: rgba(0, 0, 0, 0.54);
      }
      i {
        color: rgba(0, 0, 0, 0.54);
      }
      .service-image {
        background-color: rgba(0, 0, 0, 0.07);
      }
    }
  }
</style>
